import type { Routes } from '@angular/router';

import { COMMENTS_ROUTES } from '#modules/comments/routes/comments.routing';
import { MESSAGES_ROUTES } from '#modules/messages/routes/messages.routing';

export const INTERACTIONS_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('#shell/layouts/logged-in-layout/restaurants/interactions-layout/interactions-layout.component').then(
                (m) => m.InteractionsLayoutComponent
            ),
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'messages',
            },
            {
                path: 'messages',
                loadChildren: () => MESSAGES_ROUTES,
            },
            {
                path: 'comments',
                loadChildren: () => COMMENTS_ROUTES,
            },
        ],
    },
];
